import React from 'react';

export const UserSkeleton = ({ isGrid = false }) => (
  <div className={`bg-white rounded-lg shadow-sm border p-6 animate-pulse ${isGrid ? 'min-h-[280px]' : ''}`}>
    <div className={`flex ${isGrid ? 'flex-col items-center space-y-4' : 'items-center space-x-4'}`}>
      <div className="w-12 h-12 bg-gray-200 rounded-full flex-shrink-0"></div>
      <div className={`flex-1 ${isGrid ? 'text-center w-full' : ''}`}>
        <div className="h-4 bg-gray-200 rounded mb-2 w-3/4"></div>
        <div className="h-3 bg-gray-200 rounded mb-3 w-1/2"></div>
        <div className="flex items-center space-x-2 justify-center">
          <div className="h-5 bg-gray-200 rounded w-16"></div>
          <div className="h-4 bg-gray-200 rounded w-12"></div>
        </div>
        {isGrid && (
          <div className="mt-4 space-y-2">
            <div className="h-3 bg-gray-200 rounded w-full"></div>
            <div className="h-3 bg-gray-200 rounded w-2/3"></div>
          </div>
        )}
      </div>
      {!isGrid && (
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
          <div className="w-16 h-8 bg-gray-200 rounded"></div>
        </div>
      )}
    </div>
    {isGrid && (
      <div className="mt-6 flex justify-center space-x-2">
        <div className="w-8 h-8 bg-gray-200 rounded"></div>
        <div className="w-16 h-8 bg-gray-200 rounded"></div>
      </div>
    )}
  </div>
);

export const JobSkeleton = ({ isGrid = false }) => (
  <div className={`bg-white rounded-lg shadow-sm border p-6 animate-pulse ${isGrid ? 'min-h-[300px]' : ''}`}>
    <div className={`flex ${isGrid ? 'flex-col space-y-4' : 'items-start justify-between'}`}>
      <div className={`flex-1 ${isGrid ? 'text-center w-full' : ''}`}>
        <div className="flex items-center space-x-3 mb-3">
          <div className="h-5 bg-gray-200 rounded w-16"></div>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
        </div>
        <div className="h-5 bg-gray-200 rounded mb-2 w-3/4"></div>
        <div className="h-4 bg-gray-200 rounded mb-3 w-1/2"></div>
        {isGrid && (
          <div className="mt-4 space-y-2">
            <div className="h-3 bg-gray-200 rounded w-full"></div>
            <div className="h-3 bg-gray-200 rounded w-2/3"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        )}
      </div>
      {!isGrid && (
        <div className="flex items-center space-x-2 ml-4">
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
        </div>
      )}
    </div>
    {isGrid && (
      <div className="mt-6 flex justify-center space-x-2">
        <div className="w-8 h-8 bg-gray-200 rounded"></div>
        <div className="w-8 h-8 bg-gray-200 rounded"></div>
      </div>
    )}
  </div>
);

export const ReportSkeleton = ({ isGrid = false }) => (
  <div className={`bg-white rounded-lg shadow-sm border p-6 animate-pulse ${isGrid ? 'min-h-[320px]' : ''}`}>
    <div className={`flex ${isGrid ? 'flex-col space-y-4' : 'items-start justify-between'}`}>
      <div className={`flex-1 ${isGrid ? 'text-center w-full' : ''}`}>
        <div className="flex items-center space-x-3 mb-3">
          <div className="h-5 bg-gray-200 rounded w-12"></div>
          <div className="h-5 bg-gray-200 rounded w-16"></div>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
        </div>
        <div className="h-5 bg-gray-200 rounded mb-2 w-3/4"></div>
        <div className="h-4 bg-gray-200 rounded mb-3 w-full"></div>
        {isGrid && (
          <div className="mt-4 space-y-2">
            <div className="h-3 bg-gray-200 rounded w-full"></div>
            <div className="h-3 bg-gray-200 rounded w-2/3"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        )}
      </div>
      {!isGrid && (
        <div className="flex items-center space-x-2 ml-4">
          <div className="w-8 h-8 bg-gray-200 rounded"></div>
          <div className="w-16 h-8 bg-gray-200 rounded"></div>
        </div>
      )}
    </div>
    {isGrid && (
      <div className="mt-6 flex justify-center space-x-2">
        <div className="w-8 h-8 bg-gray-200 rounded"></div>
        <div className="w-16 h-8 bg-gray-200 rounded"></div>
      </div>
    )}
  </div>
);
